import { Button, makeStyles, TextField } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';

const useStyles = makeStyles((theme) => ({
  input: {
    marginTop: '20px',
  },
}));

function useForm(e) {
  const [entries, setEntries] = useState([]);
  const { id } = useParams();

  useEffect(() => {
    fetch(`https://api.edicionesmilenio.com/api/admins/${id}`)
      .then((response) => response.json())
      .then((data) => {
        setEntries(data?.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  function handleChange(e) {
    let { name, value } = e.target;
    setEntries({ ...entries, [name]: value });
  }

  return {
    handleChange,
    entries,
  };
}

export default function UpdateAdmin() {
  const classes = useStyles();
  const { handleChange, entries } = useForm();
  const navigate = useNavigate();

  const handleUpdate = async () => {
    try {
      let response = await fetch(
        `https://api.edicionesmilenio.com/api/admins/${entries?._id}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(entries),
        }
      );
      let data = await response.json();
      if (data.success === true) {
        navigate('/admin/admins', { replace: true });
      } else {
        console.error(data.message);
        window.alert('Error al actualizar el administrador, intente de nuevo');
      }
    } catch (error) {
      console.error(error);
      window.alert('Error al actualizar el administrador, intente de nuevo');
    }
  };

  return (
    <div
      style={{
        width: '100%',
        paddingLeft: '20px',
        paddingRight: '20px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <p
        style={{
          width: '100%',
          color: '#888',
          marginBottom: '50px',
          alignSelf: 'center',
          justifySelf: 'center',
          textAlign: 'center',
        }}
      >
        Estimado administrador, desde esta sección podrás actualizar un
        administrador para la plataforma, los administradores tienen el control
        total de la misma.
      </p>
      <div
        style={{
          width: '100%',
          paddingLeft: '20px',
          paddingRight: '20px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <TextField
          className={classes.input}
          label="Usuario"
          variant="outlined"
          name="username"
          onChange={handleChange}
          value={entries?.username || ''}
        />
        <TextField
          className={classes.input}
          label="Contraseña"
          variant="outlined"
          name="password"
          onChange={handleChange}
          value={entries?.password || ''}
          type={'password'}
        />
        <Button
          onClick={handleUpdate}
          className={classes.input}
          variant="contained"
          color="primary"
          disabled={!entries?.username || !entries?.password}
        >
          Actualizar
        </Button>
      </div>
    </div>
  );
}
